import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/MyOffice/avatar.png")